import React from "react";
import { Download, FileText, ScrollText, Landmark, Clock } from "lucide-react";

const READY = [
  { i: <ScrollText size={22}/>, t: "Why-MAVULA Investor One-Pager",
    d: "Positioning + Dubai comparison + 4 commitments — one page, plain English. SAMPLE watermarked on every page — pending UK solicitor sign-off.",
    href: "/downloads/Why-MAVULA.pdf", sample: true },
  { i: <FileText size={22}/>, t: "Title Deed Reader — Plain Language Guide",
    d: "How to read any title deed. What each clause means. Red flags to watch for. SAMPLE watermarked — educational only, not legal advice.",
    href: "/downloads/MAVULA-Title-Deed-Guide.pdf", sample: true },
];

const COMING = [
  { i: <FileText size={22}/>, t: "Full Terms — Plain Language",     d: "The MAVULA contract, written the way a friend would explain it." },
  { i: <ScrollText size={22}/>, t: "Sample Title Deed Preview",     d: "Exactly what your title deed will look like, side-by-side with a real one." },
  { i: <Landmark  size={22}/>, t: "Independent Lawyer Report",      d: "How our Title Guardians verify every deed — the review checklist." },
  { i: <FileText size={22}/>, t: "Country Guide · Botswana",         d: "Property law summary + step-by-step for buyers in Botswana." },
  { i: <FileText size={22}/>, t: "Country Guide · Zimbabwe",         d: "Property law summary + step-by-step for buyers in Zimbabwe." },
  { i: <FileText size={22}/>, t: "Country Guide · South Africa",     d: "Property law summary + step-by-step for buyers in South Africa." },
  { i: <FileText size={22}/>, t: "Country Guide · Namibia",          d: "Property law summary + step-by-step for buyers in Namibia." },
  { i: <FileText size={22}/>, t: "Country Guide · Eswatini",         d: "Property law summary + step-by-step for buyers in Eswatini." },
];

export default function DownloadsPage() {
  return (
    <main className="max-w-6xl mx-auto px-4 md:px-8 py-14 md:py-20" data-testid="downloads-page">
      <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Everything you can read before you decide</span></div>
      <h1 className="font-display text-4xl md:text-5xl mv-green-text mt-3">
        Documents & Downloads. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>Plain-language. Small files.</span>
      </h1>
      <p className="mt-4 max-w-2xl text-[15px]" style={{ color: "var(--mv-muted)" }}>
        All files are small (works on any phone) and free. Every document currently marked <strong style={{ color: "#8a2020" }}>SAMPLE</strong> is illustrative only and clearly watermarked — real, legally-signed versions will replace them once our UK solicitors sign off.
      </p>

      {/* Ready */}
      <div className="mt-10">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>Available now</span></div>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="downloads-ready">
          {READY.map((r) => (
            <a key={r.t} href={r.href} download className="mv-card p-6 group hover:-translate-y-1 transition-transform relative" data-testid={`dl-${r.t.split(" ")[0].toLowerCase()}`}>
              {r.sample && (
                <span
                  className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-[0.18em] px-2 py-0.5 rounded-full"
                  style={{ background: "rgba(212,60,60,0.12)", color: "#8a2020" }}
                  data-testid="dl-sample-tag"
                >SAMPLE</span>
              )}
              <div className="flex items-start justify-between gap-3">
                <div className="w-11 h-11 rounded-2xl flex items-center justify-center mv-green-text" style={{ background: "rgba(212,175,55,0.16)" }}>{r.i}</div>
                <Download size={18} className="mv-green-text opacity-40 group-hover:opacity-100"/>
              </div>
              <div className="mt-4 font-display text-lg mv-green-text">{r.t}</div>
              <p className="mt-1 text-[13.5px]" style={{ color: "var(--mv-muted)" }}>{r.d}</p>
              <div className="mt-3 text-[12px] font-semibold" style={{ color: "var(--mv-gold)" }}>Download PDF →</div>
            </a>
          ))}
        </div>
      </div>

      {/* Coming soon */}
      <div className="mt-12">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>Coming next — released as they are legally reviewed</span></div>
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="downloads-coming">
          {COMING.map((c) => (
            <div key={c.t} className="mv-card p-4 flex items-start gap-3" style={{ background: "linear-gradient(180deg, #fff, rgba(212,175,55,0.04))" }}>
              <div className="w-9 h-9 rounded-2xl flex items-center justify-center mv-green-text shrink-0" style={{ background: "rgba(212,175,55,0.16)" }}>{c.i}</div>
              <div className="flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <div className="font-display text-[15px] mv-green-text">{c.t}</div>
                  <span className="text-[10.5px] px-2 py-0.5 rounded-full inline-flex items-center gap-1" style={{ background: "rgba(212,175,55,0.16)", color: "#8a6b12" }}>
                    <Clock size={11}/> being reviewed
                  </span>
                </div>
                <p className="mt-1 text-[13px]" style={{ color: "var(--mv-muted)" }}>{c.d}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
